import { getLinkFromSearchEntity } from "./searchDefaults";
import { RecordLink } from "../blocks/layout/RecordLink";
import { RecordTableColumn } from "../blocks/layout/RecordTable.types";
import { SearchColumn, SearchRecord } from "./advancedSearch.types";
import { displayFieldValue } from "./displayFieldValue";

const NAME_COLUMN = "name";

/** The linked record's id column, aliased the same way as the field when it is joined. */
function linkedIdName(column: SearchColumn) {
  const linkedId = column.linkedEntityId;

  if (!linkedId || !column.name.includes(".")) {
    return linkedId;
  }

  const alias = `${column.name.split(".")[0]}.`;

  return linkedId.startsWith(alias) ? linkedId : `${alias}${linkedId}`;
}

/** The Name column, linked to the record, and a column for each of the searched fields. */
export function getResultColumns(
  entityName: string,
  columns: SearchColumn[]
): RecordTableColumn<SearchRecord>[] {
  const route = getLinkFromSearchEntity([
    { Key: "advancedSearchEntityName", Value: entityName },
  ]) as string;

  return [
    {
      key: NAME_COLUMN,
      label: "Name",
      width: 250,
      accessor: (record) =>
        route ? (
          <RecordLink to={route} id={record.Id} text={record.Name} newTab="button" />
        ) : (
          record.Name || "-"
        ),
    },
    ...columns.map((column) => ({
      key: column.name,
      label: column.label,
      width: 200,
      sortable: true,
      accessor: (record: SearchRecord) => {
        const value = displayFieldValue(record.Fields?.[column.name], column, record, entityName);
        const linkedId = linkedIdName(column);
        const target = linkedId && column.linkForNewRecord ? record.Fields?.[linkedId] : null;

        return target ? (
          <RecordLink to={String(column.linkForNewRecord)} id={target} text={value} newTab />
        ) : (
          value
        );
      },
    })),
  ];
}
